export default class Cards {
    constructor(element) {
        this.wrapper = element.querySelector(".case-cards-wrapper");
        this.cards = this.wrapper.querySelectorAll(".case-cards-card");
        this.interval = undefined;

        this.wrapper.addEventListener("mouseenter", (event) => {
            this.start();
        })

        this.wrapper.addEventListener("mouseleave", (event) => {
            this.stop();
        })
    }

    stop() {
        clearInterval(this.interval)
    }

    start() {
        let maxIndex = this.cardCount() - 1;
        let index = 0;
        this.interval = setInterval(() => {
            index = (index === maxIndex) ? 0 : index + 1;
            this.showAtIndex(index);
        }, 800)
    }

    cardCount() {
        return this.cards.length;
    }

    showAtIndex(index) {
        this.cards.forEach(function (card, i) {
            if (i === index) {
                card.classList.add("active")
            } else {
                card.classList.remove("active")
            }
        });
    }
}
